import React from 'react';
import {
  LayoutDashboard,
  BookOpen,
  Sparkles,
  MessageCircle,
  BarChart3,
  Settings,
  User,
  Upload,
  Search,
  Download,
  Share2,
  Pencil,
  Trash2,
  CheckCircle,
  AlertTriangle,
  XCircle,
  Info,
  Check,
  X,
  Play,
  Clock,
  Menu,
  Maximize2,
  Minimize2,
  RefreshCw,
  Bell,
  MessageSquare,
  Mail,
  MessageSquarePlus,
  FileText,
  Folder,
  File,
  Image as ImageIconLucide,
  Bot,
  Brain,
  Database,
  LogOut,
  type LucideIcon,
} from 'lucide-react';

export interface BaseIconProps {
  size?: number | string;
  className?: string;
  color?: string;
}

function wrapLucide(Icon: LucideIcon): React.FC<BaseIconProps> {
  return ({ size = 24, className = '', color, ...rest }) => (
    <Icon
      size={typeof size === 'string' ? undefined : size}
      className={className}
      color={color}
      {...rest}
    />
  );
}

// Navigation
export const WorkspaceIcon = wrapLucide(LayoutDashboard);
export const KnowledgeIcon = wrapLucide(BookOpen);
export const ActionsIcon = wrapLucide(Sparkles);
export const ChatIcon = wrapLucide(MessageCircle);
export const AnalyticsIcon = wrapLucide(BarChart3);
export const SettingsIcon = wrapLucide(Settings);
export const ProfileIcon = wrapLucide(User);

// Actions
export const UploadIcon = wrapLucide(Upload);
export const SearchIcon = wrapLucide(Search);
export const DownloadIcon = wrapLucide(Download);
export const ShareIcon = wrapLucide(Share2);
export const EditIcon = wrapLucide(Pencil);
export const DeleteIcon = wrapLucide(Trash2);

// Status
export const SuccessIcon = wrapLucide(CheckCircle);
export const WarningIcon = wrapLucide(AlertTriangle);
export const ErrorIcon = wrapLucide(XCircle);
export const InfoIcon = wrapLucide(Info);

// Workflow
export const ApproveIcon = wrapLucide(Check);
export const RejectIcon = wrapLucide(X);
export const ExecuteIcon = wrapLucide(Play);
export const PendingIcon = wrapLucide(Clock);

// UI
export const MenuIcon = wrapLucide(Menu);
export const CloseIcon = wrapLucide(X);
export const ExpandIcon = wrapLucide(Maximize2);
export const CollapseIcon = wrapLucide(Minimize2);
export const RefreshIcon = wrapLucide(RefreshCw);

// Communication
export const NotificationIcon = wrapLucide(Bell);
export const MessageIcon = wrapLucide(MessageSquare);
export const EmailIcon = wrapLucide(Mail);
export const FeedbackIcon = wrapLucide(MessageSquarePlus);

// Files
export const DocumentIcon = wrapLucide(FileText);
export const FolderIcon = wrapLucide(Folder);
export const FileIcon = wrapLucide(File);
export const ImageIcon = wrapLucide(ImageIconLucide);

// AI/Tech
export const AIIcon = wrapLucide(Bot);
export const BrainIcon = wrapLucide(Brain);
export const RobotIcon = wrapLucide(Bot);
export const DatabaseIcon = wrapLucide(Database);

// Auth (used by Navbar)
export const LogoutIcon = wrapLucide(LogOut);

export const SemanticIcons = {
  Workspace: WorkspaceIcon,
  Knowledge: KnowledgeIcon,
  Actions: ActionsIcon,
  Chat: ChatIcon,
  Analytics: AnalyticsIcon,
  Settings: SettingsIcon,
  Profile: ProfileIcon,
  Upload: UploadIcon,
  Search: SearchIcon,
  Download: DownloadIcon,
  Share: ShareIcon,
  Edit: EditIcon,
  Delete: DeleteIcon,
  Success: SuccessIcon,
  Warning: WarningIcon,
  Error: ErrorIcon,
  Info: InfoIcon,
  Approve: ApproveIcon,
  Reject: RejectIcon,
  Execute: ExecuteIcon,
  Pending: PendingIcon,
  Menu: MenuIcon,
  Close: CloseIcon,
  Expand: ExpandIcon,
  Collapse: CollapseIcon,
  Refresh: RefreshIcon,
  Notification: NotificationIcon,
  Message: MessageIcon,
  Email: EmailIcon,
  Feedback: FeedbackIcon,
  Document: DocumentIcon,
  Folder: FolderIcon,
  File: FileIcon,
  Image: ImageIcon,
  AI: AIIcon,
  Brain: BrainIcon,
  Robot: RobotIcon,
  Database: DatabaseIcon,
  Logout: LogoutIcon,
} as const;

export type SemanticIconType = keyof typeof SemanticIcons;
